import { Box, Button, Grid } from "@mui/material";
import ContactUsBanner from "../../assets/img/images/Hero_Section.jpg";
import Map from "./Map/Map";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationId } from "../../api/url";
import { toast } from "react-toastify";
import { postContactUs } from "../../services/contactUsService";
import { Formik } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Contact_US_Facility,
  ReCAPTCHA_sitekey,
  Reconditioning_Process,
} from "../../Utils/Constants";
import FacilityOne from "../../assets/img/images/facility/facility-1.jpg";
import FacilityTwo from "../../assets/img/images/facility/facility-2.jpg";
import FacilityThree from "../../assets/img/images/facility/facility-3.jpg";
import FacilityFour from "../../assets/img/images/facility/facility-4.jpg";
import ThumbnailImage from "../../assets/img/images/facility/facility.png";
import PlayIcon from "../../assets/img/svg/play-circle.svg";
import FacilityVideo from "../../assets/img/video/facility.mp4";
import { PlayArrow } from "@mui/icons-material";
import { Path } from "../../Utils/ScreenPath";
import { getMachineDetailsByID } from "../../services/machineService";

const Process_Card = ({ item }) => {
  return (
    <Box className="Process_Card_Box">
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box className="Process_Card_Title">{item.title}</Box>
        {item.index ? (
          <Box className="Process_Card_Index">
            <img src={item.index} alt="" />
          </Box>
        ) : null}
      </Box>
      <Box className="Process_Card_Sub_Title">{item.subTitle}</Box>
    </Box>
  );
};

const Card = ({ item }) => {
  return (
    <Box className="Reconditioning_Option_Card">
      <Box display={"flex"}>
        <Box className="Process_Card_Index">{item.index}</Box>
      </Box>
      <Box className="Process_Card_Title" paddingLeft={"0px"}>
        {item.title}
      </Box>
      <Box className="Process_Card_Sub_Title" paddingLeft={"0px"}>
        {item.subTitle}
      </Box>
    </Box>
  );
};

const ContactUsComponentV2 = () => {
  const { state } = useLocation();
  const { id, unit } = useParams();
  const inventoryLabel = state?.encodedData
    ? decodeURIComponent(state.encodedData)
    : unit
    ? decodeURIComponent(unit)
    : "";
  const machineId = state?.id || id;
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const reCaptchaRef = useRef(null);
  const { t } = useTranslation();

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play().catch((error) => {
          console.error("Autoplay failed:", error);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };

  const AccSchema = Yup.object().shape({
    firstname: Yup.string().required("Please Enter First Name"),
    lastname: Yup.string().required("Please Enter Last Name"),
    companyname: Yup.string(),
    email: Yup.string()
      .email("Enter Valid Email Address")
      .required("Please Enter E-mail Address"),
    message: Yup.string().required("Please Enter message"),
    phone: Yup.string().required("Please Enter Phone Number"),
    reCaptcha: Yup.string().required("recaptcha is a required field"),
  });

  const handleSubmitForm = async (value, resetForm) => {
    const htmlForm = `
  <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 40px; color: #131215;">
  <div style="max-width: 650px; margin: 0 auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
    
    <div style="background-color: #131215; padding: 20px; text-align: center;">
      <img
        src="https://vizybilitystorage.blob.core.windows.net/company-logos/Marcel/email_logo.png?sp=r&st=2025-11-11T12:51:32Z&se=2030-12-30T21:06:32Z&spr=https&sv=2024-11-04&sr=b&sig=gdcFKJOpCuFdG3Yzg9qz%2FIQnUZlJ%2BIwfWpTpDQ976Yw%3D"
        alt="Company Logo"
        style="max-width: 180px; display:block; margin:0 auto;"
      />
    </div>

    <div style="padding: 25px 30px 10px 30px; text-align: center; border-bottom: 3px solid #facd3f;">
      <h2 style="color: #131215; font-size: 22px; margin: 0;">New Contact Form Submission</h2>
      <p style="color: #86848e; font-size: 14px; margin-top: 6px;">You’ve received a new message from your website</p>
    </div>

    <div style="padding: 20px 30px;">
      <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">First Name</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.firstname ?? ""
          }</td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Last Name</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.lastname ?? ""
          }</td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Company Name</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.companyname ?? ""
          }</td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Email</td>
          <td style="font-size: 16px; color: #86848e;">
            <a href="mailto:${
              value?.email ?? ""
            }" style="color: #131215; text-decoration: none; border-bottom: 1px solid #facd3f;">${
      value?.email ?? ""
    }</a>
          </td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Phone</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.phone ?? ""
          }</td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Location</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.location ?? ""
          }</td>
        </tr>
        <tr>
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215; vertical-align: top;">Message</td>
          <td style="font-size: 16px; color: #86848e; line-height: 1.5; padding-right: 20px; word-break: break-word;">
            ${value?.message ?? ""}
          </td>
        </tr>
      </table>
    </div>

    <div style="background-color: #131215; color: #ffffff; text-align: center; padding: 15px;">
      <p style="margin: 0; font-size: 14px;">© ${new Date().getFullYear()} Marcel Equipment. All rights reserved.</p>
      <p style="margin: 5px 0 0 0; font-size: 13px;">
        <a href="https://marcelequipment.com" style="color: #facd3f; text-decoration: none;">marcelequipment.com</a>
      </p>
    </div>

  </div>
</div>

`;
    const htmlFormWidthInventory = `
    <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 40px; color: #131215;">
  <div style="max-width: 650px; margin: 0 auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
    
    <!-- Header -->
    <div style="background-color: #131215; padding: 20px; text-align: center;">
     <img
        src="https://vizybilitystorage.blob.core.windows.net/company-logos/Marcel/email_logo.png?sp=r&st=2025-11-11T12:51:32Z&se=2030-12-30T21:06:32Z&spr=https&sv=2024-11-04&sr=b&sig=gdcFKJOpCuFdG3Yzg9qz%2FIQnUZlJ%2BIwfWpTpDQ976Yw%3D"
        alt="Company Logo"
        style="max-width: 180px; display:block; margin:0 auto;"
      />
    </div>

    <!-- Title -->
    <div style="padding: 25px 30px 10px 30px; text-align: center; border-bottom: 3px solid #facd3f;">
      <h2 style="color: #131215; font-size: 22px; margin: 0;">New Contact Submission</h2>
      <p style="color: #86848e; font-size: 14px; margin-top: 6px;">You’ve received a new inquiry via the website</p>
    </div>

    <!-- Content Table -->
    <div style="padding: 20px 30px 30px 30px;">
      <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
        
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Name</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.firstname ?? ""
          }</td>
        </tr>

        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Last</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.lastname ?? ""
          }</td>
        </tr>
        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Company Name</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.companyname ?? ""
          }</td>
        </tr>

        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Email</td>
          <td style="font-size: 16px; color: #131215;">
            <a href="mailto:${
              value?.email ?? ""
            }" style="color: #131215; text-decoration: none; border-bottom: 2px solid #facd3f;">
              ${value?.email ?? ""}
            </a>
          </td>
        </tr>

        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Phone</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.phone ?? ""
          }</td>
        </tr>

        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Inventory</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.inventory ?? ""
          }</td>
        </tr>

        <tr style="border-bottom: 1px solid #e6e6e6;">
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215;">Location</td>
          <td style="font-size: 16px; color: #86848e;">${
            value?.location ?? ""
          }</td>
        </tr>

        <tr>
          <td style="font-weight: bold; font-size: 16px; padding: 12px 0; color: #131215; vertical-align: top;">Message</td>
          <td style="font-size: 16px; color: #86848e; line-height: 1.5; word-break: break-word; max-width: 100%;">
            ${value?.message ?? ""}
          </td>
        </tr>
      </table>
    </div>

    <!-- Footer -->
    <div style="background-color: #131215; color: #ffffff; text-align: center; padding: 15px;">
      <p style="margin: 0; font-size: 14px;">© ${new Date().getFullYear()} Marcel Equipment. All rights reserved.</p>
      <p style="margin: 5px 0 0 0; font-size: 13px;">
        <a href="https://marcelequipment.com" style="color: #facd3f; text-decoration: none;">marcelequipment.com</a>
      </p>
    </div>

  </div>
</div>
  `;

    setIsLoading(true);
    const machineInformation = await getMachineDetailsByID(machineId)
      .then((res) => {
        let showImgList = [];
        const sortedData = [...(res?.data?.images || [])].sort(
          (a, b) => a?.order - b?.order
        );

        sortedData?.map?.((item, index) => {
          showImgList[index] = {
            original: item?.url,
            thumbnail: item?.url,
          };
        });

        return {
          imgList: showImgList,
          informention: res?.data,
        };
      })
      .catch((err) => {
        return {};
      });

    const fullEmailTemplate = (machineInformation, value) => {
      console.log("machineInformation?.imgList", machineInformation);
      return `
  <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 40px; color: #131215;">
    <div style="max-width: 700px; margin: 0 auto; background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">

      <!-- HEADER -->
      <div style="background-color: #131215; padding: 20px; text-align: center;">
      <img
        src="https://vizybilitystorage.blob.core.windows.net/company-logos/Marcel/email_logo.png?sp=r&st=2025-11-11T12:51:32Z&se=2030-12-30T21:06:32Z&spr=https&sv=2024-11-04&sr=b&sig=gdcFKJOpCuFdG3Yzg9qz%2FIQnUZlJ%2BIwfWpTpDQ976Yw%3D"
        alt="Company Logo"
        style="max-width: 180px; display:block; margin:0 auto;"
      />
    </div>

      <!-- TITLE -->
      <div style="padding: 25px 30px 10px 30px; text-align: center; border-bottom: 3px solid #facd3f;">
        <h2 style="color: #131215; font-size: 22px; margin: 0;">Machine Inquiry Received</h2>
        <p style="color: #86848e; font-size: 14px; margin-top: 6px;">A new machine inquiry has been submitted.</p>
      </div>

      <!-- MACHINE INFORMATION -->
      <div style="padding: 25px 30px 10px 30px;">
  <h3 style="font-size:18px; color:#131215; margin-bottom:10px;">Machine Information</h3>

  <!-- Two-column layout for key info -->
  <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
    <tr>
      <td style="vertical-align: top; width: 50%; padding-right: 15px;">
        <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Year</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.year || ""
            }</td>
          </tr>
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Make</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.manufacturer?.name ||
              machineInformation?.informention?.MachineMake ||
              ""
            }</td>
          </tr>
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Model</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.model?.number ||
              machineInformation?.informention?.MachineModel ||
              ""
            }</td>
          </tr>
        </table>
      </td>

      <td style="vertical-align: top; width: 50%; padding-left: 15px;">
        <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Unit #</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.unit_number || ""
            }</td>
          </tr>
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Serial #</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.serial || ""
            }</td>
          </tr>
          <tr style="border-bottom: 1px solid #e6e6e6;">
            <td style="font-weight:bold;font-size:16px;padding:10px 0;">Meter Reading</td>
            <td style="font-size:16px;color:#86848e;">${
              machineInformation?.informention?.meter_reading
                ? `${machineInformation.informention.meter_reading} ${
                    machineInformation.informention.meter_reading_unit || ""
                  }`
                : ""
            }</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Full-width location and description -->
  <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse; margin-top:15px;">
    <tr style="border-bottom: 1px solid #e6e6e6;">
      <td style="font-weight:bold;font-size:16px;padding:12px 0;width:160px;vertical-align:top;">Location</td>
      <td style="font-size:16px;color:#86848e;">${
        machineInformation?.informention?.location || ""
      }</td>
    </tr>
    <tr>
      <td style="font-weight:bold;font-size:16px;padding:12px 0;vertical-align:top;">Description</td>
      <td style="font-size:16px;color:#86848e;line-height:1.5;word-break:break-word;">
        ${
          machineInformation?.informention?.machine_description_html ||
          machineInformation?.informention?.inlist_description_html ||
          ""
        }
      </td>
    </tr>
  </table>
</div>


      

      <!-- CONTACT INFORMATION -->
      <div style="padding: 25px 30px 30px 30px;">
        <h3 style="font-size:18px;color:#131215;margin-bottom:10px;">Contact Information</h3>
        <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
          ${[
            ["First Name", value?.firstname],
            ["Last Name", value?.lastname],
            ["Company Name", value?.companyname],
            [
              "Email",
              value?.email
                ? `<a href="mailto:${value.email}" style="color:#131215;text-decoration:none;border-bottom:2px solid #facd3f;">${value.email}</a>`
                : "",
            ],
            ["Phone", value?.phone],
            ["Inventory", value?.inventory],
            ["Location", value?.location],
            ["Message", value?.message],
          ]
            .map(
              ([label, content]) => `
            <tr style="border-bottom:1px solid #e6e6e6;">
              <td style="font-weight:bold;font-size:16px;padding:12px 0;width:160px;">${label}</td>
              <td style="font-size:16px;color:#86848e;line-height:1.5;">${
                content || ""
              }</td>
            </tr>`
            )
            .join("")}
        </table>
      </div>

      <!-- FOOTER -->
      <div style="background-color:#131215;color:#fff;text-align:center;padding:15px;">
        <p style="margin:0;font-size:14px;">© ${new Date().getFullYear()} Marcel Equipment. All rights reserved.</p>
        <p style="margin:5px 0 0 0;font-size:13px;">
          <a href="https://marcelequipment.com" style="color:#facd3f;text-decoration:none;">marcelequipment.com</a>
        </p>
      </div>

    </div>
  </div>`;
    };

    setIsLoading(true);
    let payload = {
      toEmail: value?.email || "",
      HtmlContent: state?.encodedData
        ? fullEmailTemplate(machineInformation, value)
        : htmlForm,
      ApplicationId: ApplicationId,
      EmailCopyToUser: true,
      ReCaptchaResponse: value?.reCaptcha,
    };
    if (state?.unitNumber) {
      payload = {
        ...payload,
        Subject: `Marcel Equipment - Contact Us - Unit#- ${state?.unitNumber}`,
      };
    }
    postContactUs(payload)
      .then((res) => {
        reCaptchaRef?.current?.reset();
        setIsLoading(false);
        toast.success("email send successfully");
        resetForm();
      })
      .catch((err) => {
        toast.error(err?.data);
        setIsLoading(false);
      });
  };
  return (
    <>
      <Box
        style={{
          // background: `url(${ContactUsBanner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${ContactUsBanner}) center/cover no-repeat`,
        }}
        className="bg-[image:var(--image-url)]"
      >
        <Box className="container">
          <Box className="Our_Team_Banner_Title">
            Contact Us <br />
            <span
              className="Our_Team_Banner_Sub_Title"
              style={{ fontWeight: "bold", textTransform: "none" }}
            >
              Doing it Right Today… To Earn Your Business Tomorrow
            </span>
          </Box>
        </Box>
      </Box>

      <Box
        className="Our_Team_Banner_Sub_Box"
        sx={{
          paddingTop: {
            xs: "40px", // For extra small screens (mobile)
            sm: "60px", // For small screens (tablets)
            md: "80px", // For medium screens (laptops)
            lg: "100px", // For large screens (desktops)
          },
        }}
        bgcolor={"#fff"}
      >
        <Box className="container">
          <Box className="Our_Team_Banner_Sub_Title">
            Are you looking for reliable equipment for your next construction
            project or landfill operation? At Marcel Equipment Limited, we
            specialize in providing top-quality machinery tailored to meet your
            specific needs.
          </Box>
          <br />
          <Box className="Our_Team_Banner_Sub_Title">
            We are here to assist you in sourcing the right equipment to ensure
            the success of your project. Whether you require compactors, dozers,
            loaders, or any other heavy machinery, our team is ready to help.
          </Box>

          <Box
            sx={{
              paddingY: {
                xs: "40px", // For extra small screens (mobile)
                sm: "60px", // For small screens (tablets)
                md: "80px", // For medium screens (laptops)
                lg: "100px", // For large screens (desktops)
              },
            }}
          >
            <Grid container item spacing={4}>
              <Grid item xs={12} md={12} lg={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      flex: "1 1 auto", // Fills remaining space
                      overflow: "hidden", // Ensures content doesn't overflow
                    }}
                  >
                    <Map />
                  </Box>
                  <Box mt={"18px"} bgcolor={"#141215"} padding={"30px"}>
                    <Box className="contact-title">
                      Additional Ways to Connect
                    </Box>

                    <Grid container item mt={"20px"} rowSpacing={1} columnSpacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
                        <Box className="contact-phone">
                          Phone or Text:{" "}
                          <a
                            href="tel:519-686-1123"
                            style={{ textDecoration: "none", color: "#fff", whiteSpace: "nowrap" }}
                          >
                            519-686-1123
                          </a>
                        </Box>
                        <Box className="contact-phone">
                          Fax:{" "}
                          <a
                            href="tel:519-686-9350"
                            style={{ textDecoration: "none", color: "#fff", whiteSpace: "nowrap" }}
                          >
                            519-686-9350
                          </a>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
                        <Box className="contact-phone">
                          Toll Free:{" "}
                          <a
                            href="tel:800-265-5747"
                            style={{ textDecoration: "none", color: "#fff", whiteSpace: "nowrap" }}
                          >
                            800-265-5747
                          </a>
                        </Box>
                        <Box className="contact-phone">
                          Email:{" "}
                          <a
                            href="mailto:sales@marcelequipment.com"
                            style={{ textDecoration: "none", color: "#fff" }}
                          >
                            sales@marcelequipment.com
                          </a>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <Formik
                  initialValues={{
                    firstname: "",
                    lastname: "",
                    companyname: "",
                    email: "",
                    phone: "",
                    location: "",
                    message: "",
                    inventory: inventoryLabel,
                    reCaptcha: "",
                  }}
                  validationSchema={AccSchema}
                  onSubmit={(values, { resetForm }) => {
                    handleSubmitForm(values, resetForm);
                  }}
                >
                  {({
                    errors,
                    touched,
                    values,
                    handleSubmit,
                    handleChange,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid item container spacing={2} sx={{ mt: "10px" }}>
                        <Grid
                          item
                          sx={12}
                          sm={12}
                          lg={12}
                          className="get-in-touch-text"
                        >
                          Get in Touch!
                        </Grid>
                        <Grid item xs={12} sm={12} lg={6}>
                          <div className="Contact_Page_field">
                            <input
                              type="text"
                              id="userfirstname"
                              name="firstname"
                              className="contact_page_input"
                              placeholder="First Name*"
                              value={values.firstname}
                              onChange={(e) => handleChange(e)}
                            />

                            {errors.firstname && touched.firstname && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.firstname}
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={6}>
                          <div className="Contact_Page_field ml-2">
                            <input
                              type="text"
                              id="userfirstname"
                              placeholder="Last Name*"
                              name="lastname"
                              className="contact_page_input"
                              value={values.lastname}
                              onChange={(e) => handleChange(e)}
                            />

                            {errors.lastname && touched.lastname && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.lastname}
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="Contact_Page_field">
                            <input
                              type="text"
                              id="companyname"
                              placeholder="Company Name"
                              name="companyname"
                              className="contact_page_input"
                              value={values.companyname}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="Contact_Page_field">
                            <input
                              type="email"
                              id="useremail"
                              placeholder="Email Address*"
                              name="email"
                              className="contact_page_input"
                              value={values.email}
                              onChange={(e) => handleChange(e)}
                            />

                            {errors.email && touched.email && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.email}
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="Contact_Page_field">
                            <input
                              type="number"
                              id="userfirstname"
                              placeholder=" Phone Number*"
                              name="phone"
                              className="contact_page_input"
                              value={values.phone}
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.phone && touched.phone && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.phone}
                              </div>
                            )}
                          </div>
                        </Grid>
                        {inventoryLabel ? (
                          <Grid item xs={12} sm={12} lg={12}>
                            <div className="Contact_Page_field">
                              <input
                                type="text"
                                id="Inventory"
                                placeholder="Inventory"
                                name="inventory"
                                className="contact_page_input"
                                value={values.inventory}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                          </Grid>
                        ) : null}
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="Contact_Page_field">
                            <input
                              type="text"
                              id="location"
                              placeholder="Location"
                              name="location"
                              className="contact_page_input"
                              value={values.location}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="contact_grid_box_top Contact_Page_field">
                            <textarea
                              rows="5"
                              type="textarea"
                              id="message"
                              name="message"
                              className="contact_page_input_textarea"
                              value={values.message}
                              placeholder="Tell us what you're looking for and how we can help"
                              onChange={(e) => handleChange(e)}
                            />
                            {errors.message && touched.message && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.message}
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="contact_grid_box_top Contact_Page_field google_recaptch_box">
                            <ReCAPTCHA
                              ref={reCaptchaRef}
                              size="normal"
                              sitekey={ReCAPTCHA_sitekey}
                              onChange={(captchaCode) => {
                                setFieldValue("reCaptcha", captchaCode);
                                // onReCAPTCHAChange
                              }}
                            />
                            {errors.reCaptcha && touched.reCaptcha && (
                              <div
                                style={{ fontSize: 14, textAlign: "left" }}
                                className="error_message"
                              >
                                {errors.reCaptcha}
                              </div>
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <div className="button_grid">
                            <button
                              type="submit"
                              disabled={isLoading}
                              className={
                                isLoading ? "Submit_loading_btn" : "Submit_btn"
                              }
                            >
                              Send Message
                            </button>
                          </div>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          paddingY: {
            xs: "40px", // For extra small screens (mobile)
            sm: "60px", // For small screens (tablets)
            md: "80px", // For medium screens (laptops)
            lg: "100px", // For large screens (desktops)
          },
          background: "#F5F5F5",
        }}
      >
        <Box className="container">
          <Grid container spacing={"24px"}>
            <Grid item md={12} lg={6}>
              <Box className="Who_We_Are_Title" color={"#141215"}>
                Exciting News: We’ve Moved!
              </Box>
              <Box className="Our_Team_Banner_Sub_Title" marginTop={"30px"}>
                Marcel Equipment Limited is proud to announce that we’ve
                relocated to a brand-new facility. This move represents our
                commitment to continuously improving how we serve our customers
                with a state-of-the-art space designed to support our work and
                meet your needs.
              </Box>
            </Grid>
            <Grid
              item
              lg={6}
              md={0}
              xl={0}
              sx={{
                display: {
                  xs: "none", // For extra small screens (mobile)
                  sm: "none", // For small screens (tablets)
                  md: "none", // For medium screens (laptops)
                  lg: "block", // For large screens (desktops)
                },
              }}
            >
              <Box
                className={"dashboard_banner"}
                sx={{
                  background: `url(${FacilityOne})`,
                  objectFit: "cover",
                  height: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transform: "scaleX(-1)",
                }}
              />
            </Grid>
            <Grid item sm={12} md={6} lg={3}>
              <Process_Card item={Contact_US_Facility.New_Address} />
            </Grid>
            <Grid
              item
              sm={12}
              md={6}
              lg={3}
              style={{ width: "-webkit-fill-available" }}
            >
              <Process_Card item={Contact_US_Facility.Size} />
            </Grid>
            <Grid
              item
              lg={2}
              sx={{
                display: {
                  xs: "none", // For extra small screens (mobile)
                  sm: "none", // For small screens (tablets)
                  md: "none", // For medium screens (laptops)
                  lg: "block", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityTwo}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  transform: "scaleX(-1)",
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              sx={{
                display: {
                  xs: "none", // For extra small screens (mobile)
                  sm: "none", // For small screens (tablets)
                  md: "none", // For medium screens (laptops)
                  lg: "block", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityThree}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              sx={{
                display: {
                  xs: "none", // For extra small screens (mobile)
                  sm: "none", // For small screens (tablets)
                  md: "none", // For medium screens (laptops)
                  lg: "block", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityFour}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </Grid>

            <Grid
              item
              lg={0}
              md={12}
              xl={12}
              sx={{
                display: {
                  xs: "block", // For extra small screens (mobile)
                  sm: "block", // For small screens (tablets)
                  md: "block", // For medium screens (laptops)
                  lg: "none", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityOne}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  transform: "scaleX(-1)",
                }}
              />
            </Grid>
            <Grid
              item
              lg={0}
              md={4}
              sm={12}
              sx={{
                display: {
                  xs: "block", // For extra small screens (mobile)
                  sm: "block", // For small screens (tablets)
                  md: "block", // For medium screens (laptops)
                  lg: "none", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityTwo}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  transform: "scaleX(-1)",
                }}
              />
            </Grid>
            <Grid
              item
              lg={0}
              md={4}
              sm={12}
              sx={{
                display: {
                  xs: "block", // For extra small screens (mobile)
                  sm: "block", // For small screens (tablets)
                  md: "block", // For medium screens (laptops)
                  lg: "none", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityThree}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </Grid>
            <Grid
              item
              lg={0}
              md={4}
              sm={12}
              sx={{
                display: {
                  xs: "block", // For extra small screens (mobile)
                  sm: "block", // For small screens (tablets)
                  md: "block", // For medium screens (laptops)
                  lg: "none", // For large screens (desktops)
                },
              }}
            >
              <img
                src={FacilityFour}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Box position={"relative"}>
                  <video
                    ref={videoRef}
                    className="rounded-md shadow-lg"
                    width="100%"
                    height="100%"
                    onClick={togglePlayPause}
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                    poster={ThumbnailImage}
                    loop
                    playsInline
                    preload="auto"
                    src={
                      "https://vizybilitystorage.blob.core.windows.net/videos/DMSDb_MARCEL/facility.mp4?sp=r&st=2025-01-30T17:00:36Z&se=2030-01-31T18:29:36Z&spr=https&sv=2022-11-02&sr=b&sig=E8YaQodFu48EpCziWjZ1sVAsV2r3wrJIQj3KSIcU6cw%3D"
                    }
                    controls={isPlaying}
                  ></video>
                  {!isPlaying && (
                    <div
                      onClick={togglePlayPause}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 10,
                        cursor: "pointer",
                      }}
                    >
                      <img src={PlayIcon} alt="" width={"128px"} />
                    </div>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Box
            className="Options_Sub_Title"
            textAlign={"center"}
            mb={"30px"}
            sx={{
              paddingTop: {
                xs: "40px", // For extra small screens (mobile)
                sm: "60px", // For small screens (tablets)
                md: "80px", // For medium screens (laptops)
                lg: "100px", // For large screens (desktops)
              },
            }}
          >
            What This Means for You
          </Box>
          <Grid container item spacing={4}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Card item={Contact_US_Facility.State_Facilities} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Card item={Contact_US_Facility.Expanded_Facilities} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <Card item={Contact_US_Facility.Room_Growth} />
            </Grid>
          </Grid>
          <Box
            className="explore_sub_title"
            mt={"50px"}
            mb={"30px"}
            textAlign={"center"}
          >
            While the location is changing, our dedication to delivering
            reliable, high-quality equipment and exceptional service remains the
            same. Stay tuned for more updates as we prepare to welcome you to
            our new home!
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          paddingY: {
            xs: "40px", // For extra small screens (mobile)
            sm: "60px", // For small screens (tablets)
            md: "80px", // For medium screens (laptops)
            lg: "100px", // For large screens (desktops)
          },
          background: "#fff",
        }}
      >
        <Box className="container">
          <Box className="explore_title" textAlign={"center"}>
            Doing it Right Today… to Earn Your Business Tomorrow
          </Box>
          <Box
            marginTop={"20px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexWrap={"wrap"}
          >
            <Button
              className="our_team"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path?.Category);
              }}
            >
              <span style={{ minWidth: "150px" }}>Explore Our Inventory</span>
            </Button>
            <Button
              className="about_us"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path.AboutUs);
              }}
            >
              <span style={{ width: "150px" }}>ABOUT US</span>
            </Button>
            <Button
              className="contact_us"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                navigate(Path.ContactUs);
              }}
              style={{ cursor: "pointer" }}
            >
              <span style={{ width: "150px" }}>CONTACT US</span>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default ContactUsComponentV2;
